import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Scale, FileCheck, GitBranch, ShieldAlert, Calculator, HeartHandshake, Eye } from "lucide-react";
import { getSettings } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { FeatureGrid } from "@/components/site/FeatureGrid";

const ITEMS = [
  { title: "Ethics", text: "A shared code of conduct that governs how every venture operates and partners.", icon: Scale },
  { title: "Compliance", text: "Regulatory integrity maintained consistently across domains and jurisdictions.", icon: FileCheck },
  { title: "Decision Framework", text: "Clear, accountable processes for material decisions at group and operating levels.", icon: GitBranch },
  { title: "Risk", text: "Deliberate identification, monitoring, and stewardship of operational and financial risk.", icon: ShieldAlert },
  { title: "Financial Controls", text: "Consolidated oversight, reporting standards, and prudent financial management.", icon: Calculator },
  { title: "Corporate Responsibility", text: "Responsible growth that respects communities, stakeholders, and the long term.", icon: HeartHandshake },
  { title: "Transparency", text: "Consistent standards and open communication that build institutional trust.", icon: Eye },
];

export default function Governance() {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  return (
    <>
      <Seo title="Governance" path="/governance" settings={settings} description="Governance at Acharya Holdings: ethics, compliance, risk, financial controls, and transparency." />
      <PageIntro eyebrow="Governance" title="Governance is a competitive advantage."
        description="Acharya Holdings operates under a central governance framework designed to ensure capital discipline, regulatory integrity, and long-term strategic continuity across all ventures." />
      <div className="surface-cream">
        <section className="container-inst py-16 lg:py-24">
          <FeatureGrid items={ITEMS} />
        </section>
      </div>
    </>
  );
}
